
const BookNowButton = () => {
  return (
    <a
  href="https://book.squareup.com/appointments/x5406e6f9tskh6/location/LFDC8KDM9489Z/services"
  target="_blank"
  rel="noopener noreferrer"
  className="bookBtn"
    >
      Book Now
    </a>
  );
};

export default BookNowButton;